
import { defineComponent, onMounted, PropType } from 'vue'
import Sortable from 'sortablejs'

import ArtistListItem from './ArtistListItem.vue'

import { Artist, Store } from '../types'

export default defineComponent({
  name: 'ArtistList',
  components: {
    ArtistListItem,
  },
  props: {
    artists: {
      type: Array as PropType<Artist[]>,
    },
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
  },
  setup(props) {
    const selectArtist = (artistId: number): void => {
      props.emitter.emit('select-artist', artistId)
    }

    onMounted(() => {
      const el = document.getElementById('artists')

      if (el) {
        Sortable.create(el, {
          group: { name: 'timeslots', put: false, pull: true },
          sort: false,
          ghostClass: 'bg-gray-100',
          chosenClass: 'border-slipmat-600',
          onUpdate: function(evt) {
            console.log('Updated: ', evt)
          },
        })
      } else {
        console.log('FAIL: no HTML element for artists ')
      }
    })

    return {
      props,
      selectArtist,
    }
  },
})
